import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/imain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/imain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/imain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/imain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/imain/${Id}`);
  },
};
